<template>
  <div>
    <v-dialog
      v-model="r_prop"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
      max-width="500px"
    >
      <v-card class="rounded_max" v-if="inventory">
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 py-0">
          <v-container style="height: max-content" v-if="inventory.body">
            <div class="mt-2">
              <h4>Status</h4>
              <v-select
                style="width: 50%"
                dense
                outlined
                hide-details
                :items="optStatusSubmiision"
                color="green"
                item-text="txt"
                item-value="val"
                v-model="inventory.body.approval"
                placeholder="Status"
              ></v-select>
            </div>
            <div class="mt-2">
              <h4>Notes for Proposal</h4>
              <v-textarea
                class="mb-2"
                auto-grow
                outlined
                color="green"
                rows="4"
                placeholder="Put Notes for Proposal"
                v-model="inventory.body.notes"
                hide-details
                dense
              ></v-textarea>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$emit('close')">
            Close
          </v-btn>
          <v-btn
            color="green darken-1"
            v-if="
              inventory.body.notes !== '' &&
              inventory.body.approval !== 'process'
            "
            @click="updateData"
            dark
          >
            Send
          </v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
          <v-progress-circular
            indeterminate
            class="mr-2"
            color="#006341"
          ></v-progress-circular>
          <b class="color_default">Loading...</b>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "reviewProposal",
  props: ["r_prop", "inventory", "title"],
  computed: {},
  data() {
    return {
      loading: false,
      notes: "",
      optStatusSubmiision: [
        { txt: "Declined", val: "declined" },
        { txt: "Revision", val: "revision" },
        { txt: "Approved", val: "approved" },
      ],
    };
  },
  methods: {
    updateData() {
      this.loading = true;

      let data = {
        path: this.inventory.path,
        body: this.inventory.body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("close");
          this.$emit("refetch");
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.input_hide {
  display: none;
}
.title_f {
  border: solid 1px #cccccc;
  width: 100%;
  border-radius: 8px;
  /* height: 35px; */
  padding: 8px 10px;
  margin-bottom: 10px;
}
.title_f:focus {
  outline: none;
}
</style>
